import {formatNumber} from '../../../library/numberFunction';
import {formatDateTime} from './subscriptionUtils';
import {SubscriptionPlan} from '../../../redux/subscription/subscription.type';
import store from '../../../store';

export const calculateSalesFraction = (plan: SubscriptionPlan): string => {
    const salesQuantity = plan.amount - plan.amountAvailable || 0;
    const totalQuantity = plan.amount || 0;
    return `${formatNumber(salesQuantity)}/${formatNumber(totalQuantity)}`;
};

export const hasPlanSales = (plan: Pick<SubscriptionPlan, 'amount' | 'amountAvailable'>): boolean => {
    return (plan.amount - plan.amountAvailable) > 0;
};

export const calculatePriceRange = (plan: SubscriptionPlan): string => {
    const prices = plan.prices || [];
    if(prices.length === 0) return '-';
    const currencySymbol = store.getState().event.currencySymbol || '₪';
    const minPrice = Math.min(...prices.map(price => Number(price.price || 0)));
    const maxPrice = Math.max(...prices.map(price => Number(price.price || 0)));
    return minPrice === maxPrice
        ? `${formatNumber(minPrice)}${currencySymbol}`
        : `${formatNumber(maxPrice)}${currencySymbol} - ${formatNumber(minPrice)}`;
};

export const calculateSaleValidity = (plan: SubscriptionPlan): string => {
    if(!plan.saleStart || !plan.saleEnd) return '-';
    return `${formatDateTime(plan.saleStart)} - ${formatDateTime(plan.saleEnd)}`;
};

export const calculateRedemptionValidity = (plan: SubscriptionPlan): string => {
    if(!plan.usageDeadline) return '-';
    return formatDateTime(plan.usageDeadline);
};

export const calculatePercentage = (plan: SubscriptionPlan): number => {
    return formatNumber(((plan.amount - plan.amountAvailable) / plan.amount) * 100) || 0;
};
